import { BodyText, extraSmall } from '@unmind/design-system-components-web';
import { rem } from 'polished';
import { css, styled } from 'styles';

export const ChatbotSessionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`;

export const ChatbotSessionMessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  gap: ${rem(16)};

  ${extraSmall(css`
    gap: ${rem(24)};
  `)}
`;

export const ChatbotSessionTitleContainer = styled.div`
  margin-bottom: 12px;
  padding: 0 12px;
  position: relative;
`;

export const ChatbotSessionTitleBreak = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.border.secondary};
`;

export const ChatbotSessionDate = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize12],
  weight: theme.typography.fontWeights.regular,
  color: theme.colors.text.secondary,
}))`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 0px 10px;
`;
